import {TimelineLite} from "gsap/TimelineLite";

export default {

    animateLightsOn() {
        this.switchOn();
    },

    animateLightsOff() {
        this.switchOff();
    },

    switchOn() {
        document.documentElement.style.setProperty('--bg-primary', '#242526');
        document.documentElement.style.setProperty('--color-primary', '#07FDD8');
        document.documentElement.style.setProperty('--color-pink', '#b5fff2');
		document.documentElement.style.setProperty('--bg-primary-rgba', 'rgba(36, 37, 38, 0.8)');
        document.documentElement.style.setProperty('--portrait-red', '#07FDD8');

    },

    switchOff() {
        document.documentElement.style.setProperty('--bg-primary', '#030303');
        document.documentElement.style.setProperty('--color-primary', '#ff0042');
        document.documentElement.style.setProperty('--color-pink', '#ffa3bb');
		document.documentElement.style.setProperty('--bg-primary-rgba', 'rgba(0, 0, 0, 0.8)');
		document.documentElement.style.setProperty('--portrait-red', '#c70a37');
    },

    animatePointer(ref) {
    	let tl = new TimelineLite();

		tl.fromTo(ref, 0.25, {opacity: 0}, {opacity: 0.8, delay: 10});
    	tl.to(ref, 0.25, {y: -25, yoyo: true, repeat: 4});
    	tl.to(ref, 0.25, {y: 0});
		tl.to(ref, 0.25, {y: -25, yoyo: true, repeat: 4, delay: 0.5});
		tl.to(ref, 0.25, {y: 0});
    	tl.to(ref, 0.25, {opacity: 0}, '+=2');
	}

};


// WEBPACK FOOTER //
// ./src/js/components/Footer/animations.js